export enum Progress {
    NotStarted = 'Not Started',
    InProgress = 'In Progress',
    Completed = 'Completed'
}